// removed by extract-text-webpack-plugin
module.exports = {"popover":"_31mE-","title":"_2V1rU","option":"_3LKMB _1wqBz","valueLabel":"_1ho40","on":"_3ZCyR","selected":"_1f4qE"};


//////////////////
// WEBPACK FOOTER
// ./dashboard/components/RefreshWidget.css
// module id = 530
// module chunks = 3 4 5